(function ($, undefined) {
	"use strict";

	let formValidator;
	let utils;

	function init() {
		formValidator = Fw.component.models().form;
		utils = Fw.component.models().utils;
		createCaptcha();

		var url = window.location.href;
		if(url!=undefined && url!=null && url.indexOf("oauth2-user-inaccessible")!=-1){
			var updatedUrl=url.substring(0,url.indexOf("?"));
			url=url.substring(url.indexOf("oauth2-user-inaccessible:")+"oauth2-user-inaccessible:".length,url.length);
			if(url.startsWith("Please"))
				alert("OAuth2 Settings error: "+url);
			else alert("OAuth2 Settings error with Client ID: "+url);
			window.history.pushState('page2', 'Title', updatedUrl);
		}

		$("#mainCaptcha").bind("copy", function (e) {
			e.preventDefault();
		});

		$("captchaTxtInput").bind("paste", function (e) {
			e.preventDefault();
		});

		$("#otpTxtInput").val("");

		$(".otpForm").on("submit", function (e) {
			e.preventDefault();
			(formValidator = Fw.component.models().form);
			(utils = Fw.component.models().utils);
			validateFormG(e, 0, "verify-btn");
		});

		$(document).on("click", ".resend-btn", function (e) {
			const $form = $(".otpForm");
			$form.find(".resend-btn").addClass("btn-processing_active");
			hideFormError($form);
			hideFormSuccess($form);
			submitFormG($form, !$form.hasClass("login-page-form"), true, "/action/loginV2");
		});

		$('.login-page-form__captcha').on('click', createCaptcha);
		$('.login-page-form').on('submit', validateForm);
		$('#forgot-password-form').on('submit', validateForm);

		const urlParams = new URLSearchParams(window.location.search);
		const token = urlParams.get("token");

		if (token) {
		
			fetch(`/action/sbGetSession?token=${token}`)
				.then(res => res.json())
				.then(data => {
				if (data.sessionId) {
					document.cookie = `JSESSIONID=${data.sessionId}; path=/; secure; samesite=strict;`;
					// Clean the URL
					window.history.replaceState({}, document.title, "/");
					// Or reload if needed
					location.reload();
				}
				})
				.catch(err => console.error("Session fetch error:", err));
		}

	}

	function getCookie(name) {
		const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? match[2] : null;
	}

	//Younis Updates
	function validateForm(e) {
		var $form = $(e.currentTarget);
		if (!$form.hasClass("otpForm"))
			validateFormG(e, 1, "");
	}

	function submitForm($form, alwaysSuccess) {
		submitFormG($form, alwaysSuccess, false, "");
	}

	function validateFormG(e, isCaptcha, btnName) {
		var $form = $(1 == isCaptcha ? e.currentTarget : ".otpForm");
		const btn = $form.find(0 == isCaptcha ? "." + btnName : ".btn-processing");

		btn.addClass("btn-processing_active");
		e.preventDefault();
		hideFormError($form);
		hideFormSuccess($form);
		formValidator.validateForm($form);

		if ("verify-btn" == btnName && $form.hasClass("has-error") && "verify-btn" == btnName) {
			showFormError($form, "fields");
			btn.removeClass("btn-processing_active");
		} else if (1 == isCaptcha && btnName != 'verify-btn' && btnName != 'resend-btn') {
			if (ValidCaptcha() || !$form.hasClass("login-page-form"))
				submitForm($form, !$form.hasClass("login-page-form"));
			else {
				var className = $("#captchaTxtInput").attr("class");
				$("#captchaTxtInput").attr("class", className + " error");
				showFormError($form, "captcha");
				btn.removeClass("btn-processing_active");
				createCaptcha();
			}
		} else if ("resend-btn" == btnName) {
			submitFormG($form, !$form.hasClass("login-page-form"), true, "/action/loginV2");
		} else if ("verify-btn" == btnName && "" == $("#otpTxtInput").val()) {
			showFormError($form, "fields");
			btn.removeClass("btn-processing_active");
		} else {
			otpSubmitForm($form, !$form.hasClass("login-page-form"));
		}
	}//End validateFormG

	function submitFormG($form, alwaysSuccess, local, url) {
		var obj = {};
		var data = 0 == local ? $form.formData(true) : JSON.parse(localStorage.getItem("obj"));
		var key = CryptoJS.enc.Base64.parse("xxLMr2ScLLpHKfbEQzfLB3VErYPG5Xvc");

		Object.keys(data).forEach(function (i) {
			obj[i] =
				("password" != i && "username" != i) || 0 != local
					? data[i]
					: window.btoa(
						CryptoJS.AES.encrypt(unescape(data[i]), key, {
							padding: CryptoJS.pad.Pkcs7,
							mode: CryptoJS.mode.ECB,
						})
					);
		});

		const btn = $form.find(".btn-processing");
		if (localStorage.getItem("addedSeconds")) {
			var diff = new Date().getTime() / 1000 - localStorage.getItem("addedSeconds");
			if (diff <= localStorage.getItem("blockedSeconds") && diff >= 0) {
				showFormCustomError($form, "otp_blocked", " Try resend after " + Math.floor(localStorage.getItem("blockedSeconds") - diff) + " seconds.");
				btn.removeClass("btn-processing_active");
			}
		}

		$.ajax({
			url: "" == url ? $form.attr("action") : url,
			type: $form.attr("method"),
			data: obj,
		}).then((res) => {
			if(res.indexOf("oauth2-login:url-")!=-1){
				window.location = String(res).substring("oauth2-login:url-".length,res.length);
			}else if(res.indexOf("local-login")!=-1){
				$("#passwordHidden").parent().parent().removeClass("d-none");
				$("#passwordHidden").focus();
				$(".login-page-form__forgot-ctn").removeClass("d-none");
				$form.attr("action",String($form.attr("action")).replace("isOAuth2=true","isOAuth2=false"));
				btn.removeClass("btn-processing_active");
			}else if (-1 != res.indexOf("success-") || alwaysSuccess) {
				const trimmedRes = res.trim().split(":");
				
				if(!alwaysSuccess){
					var seconds = new Date().getTime() / 1000;
					localStorage.removeItem("verificationId");
					if ("" == url) localStorage.setItem("obj", JSON.stringify(obj));
					
					if(trimmedRes.length>1){
						localStorage.setItem("verificationId", trimmedRes[1].split("verificationId-")[1]);
						localStorage.setItem("username", res.trim().split(":")[2]);
						localStorage.setItem("addedSeconds", seconds);
						localStorage.setItem("blockedSeconds", trimmedRes[3].split("blockedForSecs-")[1]);
						$("#otpTxtInput").val("");
					}
					btn.removeClass("btn-processing_active");
					window.location = trimmedRes[0].split("success-")[1].trim();
				}
				showFormSuccess($form);
			} else{
				if(res.indexOf("user-inaccessible")!=-1){
					var status=res.split(":")[1].trim();
					
					showFormCustomError($form, "inaccessible",status==='d'?"User Deleted.":(status==='a'?"You do not have the access rights to log into this site. Retry on the mobile app.":"User Disabled."));
				}else{
				-1 != res.indexOf("error")
					? showFormCustomError($form, "otp_blocked", " Try resend after " + (res.split(":")[2].split("blockedForSecs-")[1] - res.split(":")[3].split("currentSecs-")[1]) + " seconds.")
					: -1 != res.indexOf("inactive")
						? showFormError($form, "inactive")
						: -1 != res.indexOf("expired")
							? showFormError($form, "expired")
							: showFormError($form, "credentials");
				}
			}
			if (-1 == res.indexOf("success-") || alwaysSuccess){
				btn.removeClass("btn-processing_active");
			}
		});
	}

	function otpSubmitForm($form, alwaysSuccess) {
		$form.formData(true);
		const btn = $form.find(".btn-processing");

		$.ajax({
			url: "/action/otpLogin",
			type: $form.attr("method"),
			data: {
				forward: "home",
				forwardFail: "otp",
				ajax: "true",
				getToken: "false",
				verificationId: localStorage.getItem("verificationId"),
				otpCode: $("#otpTxtInput").val(),
			},
		}).then((res) => {
			if (-1 != res.indexOf("success-") || alwaysSuccess) {
				const trimmedRes = res.trim().split(":");
				alwaysSuccess ||
					utils.getPerson((person) => {
						if (person.addInfo1 < 2 || person.addInfo1 > 5 || 0 == person.siteId) {
							localStorage.removeItem("verificationId");
							localStorage.removeItem("addedSeconds");
							localStorage.removeItem("blockedSeconds");
							document.cookie = `username=${encodeURIComponent(trimmedRes[1].split("username-")[1].trim())};samesite=true;max-age=31536000`;
							window.location = trimmedRes[0].split("success-")[1].trim();
						} else {
							$.ajax({
								url: "/action/logout",
								type: "POST",
								data: { ajax: true },
							});
							showFormError($form, "forbidden");
							btn.removeClass("btn-processing_active");
						}
					}),
					showFormSuccess($form);
			} else
				if(res.indexOf("user-inaccessible")){
					const trimmedRes = res.trim().split(":");
					var status=res.split(":")[1].trim();
					window.location = String(res).substring("oauth2-login:url-".length,res.length);
					showFormCustomError($form, "inaccessible",status==='d'?"User Deleted.":"User Disabled.");
				}else 
					-1 != res.indexOf("error")
						? showFormError($form, "otp")
						: -1 != res.indexOf("inactive")
							? showFormError($form, "inactive")
							: -1 != res.indexOf("expired")
								? showFormError($form, "expired")
								: showFormError($form, "credentials");
			if (-1 == res.indexOf("success-") || alwaysSuccess)
				btn.removeClass("btn-processing_active");
		});
	}

	function showFormCustomError($form, modifier, errorMessage) {
		$form.find(`.form-message_${modifier}`).html(errorMessage);
		$form.find(`.form-message_${modifier}`).slideDown(300);
	}

	function showFormSuccess($form) {
		$form.find(`.form-message_success`).slideDown(300);
	}

	function hideFormSuccess($form) {
		$form.find(`.form-message_success`).slideUp(300);
	}

	function showFormError($form, modifier, isError) {
		$form.find(`.form-message_${modifier}`).slideDown(300);
	}

	function hideFormError($form) {
		$form.find(`.form-message_error`).slideUp(300);
	}

	function createCaptcha() {
		$("#refresh").addClass("refreshAnimation");
        setTimeout(function() {
            $("#refresh").removeClass("refreshAnimation");
        }, 350);

        // var alpha = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9');
        var alpha = new Array('0', '1', '2', '3', '4', '5', '6', '7', '8', '9');
		var i;

		for (i = 0; i < 6; i++) {
			var a = alpha[Math.floor(Math.random() * alpha.length)];
			var b = alpha[Math.floor(Math.random() * alpha.length)];
			var c = alpha[Math.floor(Math.random() * alpha.length)];
			var d = alpha[Math.floor(Math.random() * alpha.length)];
			var e = alpha[Math.floor(Math.random() * alpha.length)];
			var f = alpha[Math.floor(Math.random() * alpha.length)];
			var g = alpha[Math.floor(Math.random() * alpha.length)];
		}

		var code = a + ' ' + b + ' ' + ' ' + c + ' ' + d + ' ' + e + ' ' + f + ' ' + g;
		document.getElementById("mainCaptcha") && (document.getElementById("mainCaptcha").innerHTML = code);
		document.getElementById("mainCaptcha") && (document.getElementById("mainCaptcha").value = code);
	}

	function ValidCaptcha() {
		var string1 = removeSpaces((document.getElementById('mainCaptcha') && document.getElementById('mainCaptcha').value));
		var string2 = removeSpaces((document.getElementById('captchaTxtInput') && document.getElementById('captchaTxtInput').value));

		return string1 == string2;
	}

	function removeSpaces(string) {
		return string.split(' ').join('');
	}

	$(init);

})(jQuery);